// UseEscClose.tsx
import { useEffect } from "react"

/**
 * Attaches an event listener for the "Escape" key to close a modal or a similar component.
 * @param {boolean} isOpen - Condition under which the event listener is active.
 * @param {Function} onClose - Callback function to execute when the Escape key is pressed.
 */
export const useEscClose = (isOpen: boolean, onClose: () => void) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose()
            }
        }

        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown)
        }

        return () => {
            if (isOpen) {
                document.removeEventListener("keydown", handleKeyDown)
            }
        }
    }, [isOpen, onClose]) // Ensures effect updates only if isOpen or onClose changes.
}
